module.exports = __webpack_public_path__ + "static/icon-scroll-11ad8c214229887cf1ef674cd2bb3fdd.svg";